<template>
  <div class="metting-container" v-if="metting.length > 0">
    <div class="metting-list">
      <el-row :gutter="20">
        <el-col :xs="24" :sm="12" :md="12" :lg="12" v-for="item in metting" :key="item.id">
          <div class="metting-item flex ac metting-item-box" @click="goDetail(item.id)">
            <div style="width: 80%;">
              <div class="title ellipsis">{{ item.enActivityTheme }}</div>
              <div class="date">
                <span style="margin-right: 8px;">{{ item.activityStartDate | formatDate('y-m-d') }}</span>
                <span>{{ item.activityStartDate | formatDate('hours') }}</span>
              </div>
              <div class="roomName">{{ item.enAddress }}</div>
            </div>
            <div style="margin-left: 20px;">
              <el-button size="small" type="primary">Application</el-button>
            </div>

          </div>
        </el-col>
      </el-row>
    </div>
    <div class="more-btn" @click="gomettingList()">
      <span class="pointer" style="text-decoration: underline;">{{ $t('查看更多') }}</span>
    </div>
  </div>
</template>
<script>
import { activityQueryList } from '@/api'
export default {
  data() {
    return {
      metting: ''
    }
  },
  computed: {},
  mounted() {
    activityQueryList().then(res => {
      this.metting = res.data.data.slice(0, 4)
    })
  },
  methods: {
    goDetail(id) {
      this.$router.push(`/meetingList/${id}`)
    },
    gomettingList() {
      this.$router.push('/meetingList')
    },
    formatDate(date) {
      return this.$funcs.dateFormat(date, 'YYYY-mm-dd HH:MM:SS')
    }
  },
  created() {}
}
</script>

<style lang="stylus" scoped>
.metting-item{
  background: $color-white;
  border-radius: 8px;
  padding: 16px 20px;
  margin-bottom: 16px;
}
.metting-item-box
   &:hover
    cursor pointer
    box-shadow 0 6px 5px 5px $box-shadow1, 0 6px 8px 2px $box-shadow2  
.more-btn{
  margin-top:24px;
  font-weight: 400;
  font-size: 14px;
  color: $color-main;
  line-height: 14px;
  text-align: center;
}
.title{
  font-weight: 600;
  font-size: 18px;
  color: $color-black-85;
  line-height: 24px;
  margin-bottom:16px;
}
.date{
  font-weight: 400;
  font-size: 14px;
  color: $color-black-45;
  line-height: 14px;
  margin-bottom:8px;
}
.roomName{
  color: $color-main;
  font-weight: 400;
  font-size: 14px;
  line-height: 14px;
}
</style>
